import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Col, Row } from "react-bootstrap";

import toast from "react-hot-toast";
import { editSettings, getSettings } from "store/actions";
import { useDispatch, useSelector } from "react-redux";
import ImageUpdate from "components/shared/ImageUpdate";

const Index = () => {
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  const { settings } = useSelector((state) => state.settings);

  const [appLogo, setAppLogo] = useState({
    preview: null,
    path: null,
  });

  const [footerBackground, setFooterBackground] = useState({
    preview: null,
    path: null,
  });

  useEffect(() => {
    dispatch(getSettings());
  }, [dispatch]);

  useEffect(() => {
    reset({
      address: settings?.address,
      address_2: settings?.address_2,
      description: settings?.description,
      copyrights: settings?.copyrights,
      email: settings?.email,
      phone: settings?.phone,
      phone_1: settings?.phone_1,
      phone_2: settings?.phone_2,
      mapIframe: settings?.mapIframe,
      mapIframe_2: settings?.mapIframe_2,
    });

    setAppLogo({
      preview: settings?.logo,
      path: settings?.logo,
    });

    setFooterBackground({
      preview: settings?.footerBackground,
      path: settings?.footerBackground,
    });
  }, [reset, settings]);

  const onSubmit = async (data) => {
    data.logo = appLogo.path;
    data.footerBackground = footerBackground.path;

    dispatch(
      editSettings({
        id: settings?._id,
        data,
        toast,
      })
    );
  };

  return (
    <>
      <div className="acc-form">
        <div className="card card-settings">
          <div className="card-head">
            <h4>إعدادات الموقع</h4>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit(onSubmit)}>
              <Col xxl={8} lg={12} md={12}>
                <Row>
                  <Col lg={12}>
                    <div className="form-group required">
                      <h5>شعار الموقع</h5>
                      <ImageUpdate
                        selectedImage={appLogo}
                        setSelectedImage={setAppLogo}
                      />
                    </div>
                  </Col>
                  <Col lg={12} xs={12}>
                    <div className="form-group required">
                      <h5>البريد الالكتروني </h5>
                      <div>
                        <input
                          type="text"
                          className="form-control form-outline"
                          placeholder="البريد الالكتروني "
                          {...register("email", { required: true })}
                        />
                      </div>
                      <p className="error-hint">
                        {errors?.email && "يرجي ادخال البريد الالكتروني "}
                      </p>
                    </div>
                  </Col>
                  <Col lg={6} xs={12}>
                    <div className="form-group required">
                      <h5>عنوان الادارة</h5>
                      <div>
                        <input
                          type="text"
                          className="form-control form-outline"
                          placeholder="عنوان الادارة"
                          {...register("address")}
                        />
                      </div>
                      <p className="error-hint">
                        {errors?.address && "يرجي ادخال عنوان الادارة"}
                      </p>
                    </div>
                  </Col>
                  <Col lg={6} xs={12}>
                    <div className="form-group required">
                      <h5>عنوان المصنع</h5>
                      <div>
                        <input
                          type="text"
                          className="form-control form-outline"
                          placeholder="عنوان المصنع"
                          {...register("address_2")}
                        />
                      </div>
                      <p className="error-hint">
                        {errors?.address_2 && "يرجي ادخال عنوان المصنع"}
                      </p>
                    </div>
                  </Col>
                  <Col lg={4} xs={12}>
                    <div className="form-group required">
                      <h5>هاتف ادارة 1</h5>
                      <div>
                        <input
                          type="text"
                          className="form-control form-outline"
                          placeholder="هاتف ادارة 1"
                          {...register("phone")}
                        />
                      </div>
                      <p className="error-hint">
                        {errors?.phone && "يرجي ادخال هاتف ادارة 1"}
                      </p>
                    </div>
                  </Col>
                  <Col lg={4} xs={12}>
                    <div className="form-group required">
                      <h5>هاتف ادارة 2</h5>
                      <div>
                        <input
                          type="text"
                          className="form-control form-outline"
                          placeholder="هاتف ادارة 2"
                          {...register("phone_1")}
                        />
                      </div>
                      <p className="error-hint">
                        {errors?.phone_1 && "يرجي ادخال هاتف ادارة 2"}
                      </p>
                    </div>
                  </Col>
                  <Col lg={4} xs={12}>
                    <div className="form-group required">
                      <h5>هاتف المصنع </h5>
                      <div>
                        <input
                          type="text"
                          className="form-control form-outline"
                          placeholder="هاتف المصنع "
                          {...register("phone_2")}
                        />
                      </div>
                      <p className="error-hint">
                        {errors?.phone_2 && "يرجي ادخال هاتف المصنع "}
                      </p>
                    </div>
                  </Col>

                  <Col lg={6} xs={12}>
                    <div className="form-group required">
                      <h5>خريطة الادراة</h5>
                      <div>
                        <textarea
                          className="form-control form-outline"
                          placeholder="خريطة الادارة"
                          {...register("mapIframe")}
                        ></textarea>
                      </div>
                      <p className="error-hint">
                        {errors?.mapIframe && "يرجي ادخال خريطة الادارة "}
                      </p>
                    </div>
                  </Col>
                  <Col lg={6} xs={12}>
                    <div className="form-group required">
                      <h5>خريطة المصنع</h5>
                      <div>
                        <textarea
                          className="form-control form-outline"
                          placeholder="خريطة المصنع"
                          {...register("mapIframe_2")}
                        ></textarea>
                      </div>
                      <p className="error-hint">
                        {errors?.mapIframe_2 && "يرجي ادخال خريطة المصنع "}
                      </p>
                    </div>
                  </Col>

                  <Col lg={12} xs={12}>
                    <div className="form-group required">
                      <h5>وصف الموقع</h5>
                      <div>
                        <textarea
                          className="form-control form-outline"
                          placeholder="وصف الموقع"
                          {...register("description")}
                        ></textarea>
                      </div>
                      <p className="error-hint">
                        {errors?.description && "يرجي ادخال وصف الموقع "}
                      </p>
                    </div>
                  </Col>

                  <Col lg={12} xs={12}>
                    <div className="form-group required">
                      <h5>حقوق الموقع </h5>
                      <div>
                        <input
                          type="text"
                          className="form-control form-outline"
                          placeholder="حقوق الموقع "
                          {...register("copyrights")}
                        />
                      </div>
                      <p className="error-hint">
                        {errors?.copyrights && "يرجي ادخال حقوق الموقع "}
                      </p>
                    </div>
                  </Col>

                  <Col lg={12}>
                    <div className="form-group required upload-cover">
                      <h5>خلفية الفوتر</h5>
                      <ImageUpdate
                        selectedImage={footerBackground}
                        setSelectedImage={setFooterBackground}
                      />
                    </div>
                  </Col>

                  <Col lg={4} xs={12}>
                    <div className="form-group">
                      <button type="submit" className="btn btn-blue">
                        حفظ
                      </button>
                    </div>
                  </Col>
                </Row>
              </Col>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Index;
